"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManifestTemplate = exports.ScaffoldProgressMessage = exports.ProgressTitleMessage = exports.TelemetryValue = exports.TelemetryKey = exports.Constants = void 0;
const localizeUtils_1 = require("../../../../common/localizeUtils");
// Licensed under the MIT license.
class Constants {
}
exports.Constants = Constants;
Constants.PLUGIN_NAME = "SPFx";
Constants.PLUGIN_DEV_NAME = "fx-resource-spfx";
Constants.SetUpDevEnvironmentHelpLink = "https://aka.ms/teamsfx-spfx-dev-environment-setup";
Constants.TEMPLATE_NAME = "spfx-tab";
Constants.LatestVersion = "latest";
Constants.RecommendedLowestSpfxVersion = "v1.14.0";
Constants.GeneratorPackageName = "@microsoft/generator-sharepoint";
Constants.YeomanPackageName = "yo";
Constants.DEFAULT_WEBPART_NAME = "helloworld";
Constants.ScaffoldHelpLink = "https://aka.ms/teamsfx-spfx-help-v5";
Constants.DevProgramLink = "https://developer.microsoft.com/en-us/microsoft-365/dev-program";
Constants.YO_RC_SOLUTION_NAME = "solutionName";
Constants.IMPORT_HELP_LINK = "https://aka.ms/teamsfx-spfx-help-v5";
Constants.TEAMS_APP_NAME_MAX_LENGTH = 30;
class TelemetryKey {
}
exports.TelemetryKey = TelemetryKey;
TelemetryKey.Component = "component";
TelemetryKey.Success = "success";
TelemetryKey.ErrorType = "error-type";
TelemetryKey.ErrorMessage = "error-message";
TelemetryKey.ErrorCode = "error-code";
class TelemetryValue {
}
exports.TelemetryValue = TelemetryValue;
TelemetryValue.Success = "yes";
TelemetryValue.Fail = "no";
TelemetryValue.UserError = "user";
TelemetryValue.SystemError = "system";
class ProgressTitleMessage {
}
exports.ProgressTitleMessage = ProgressTitleMessage;
ProgressTitleMessage.PreDeployProgressTitle = localizeUtils_1.getLocalizedString("plugins.spfx.buildSharepointPackage");
ProgressTitleMessage.DeployProgressTitle = localizeUtils_1.getLocalizedString("plugins.spfx.deploy.title");
ProgressTitleMessage.ScaffoldProgressTitle = localizeUtils_1.getLocalizedString("plugins.spfx.scaffold.title");
ProgressTitleMessage.AddProgressTitle = localizeUtils_1.getLocalizedString("driver.spfx.add.progress.title");
class ScaffoldProgressMessage {
}
exports.ScaffoldProgressMessage = ScaffoldProgressMessage;
ScaffoldProgressMessage.DependencyCheck = localizeUtils_1.getLocalizedString("plugins.spfx.scaffold.dependencyCheck");
ScaffoldProgressMessage.DependencyInstall = localizeUtils_1.getLocalizedString("plugins.spfx.scaffold.dependencyInstall");
ScaffoldProgressMessage.ScaffoldProject = localizeUtils_1.getLocalizedString("plugins.spfx.scaffold.scaffoldProject");
ScaffoldProgressMessage.UpdateManifest = localizeUtils_1.getLocalizedString("plugins.spfx.scaffold.updateManifest");
class ManifestTemplate {
}
exports.ManifestTemplate = ManifestTemplate;
ManifestTemplate.LOCAL_CONTENT_URL = "https://{teamSiteDomain}/_layouts/15/TeamsLogon.aspx?SPFX=true&dest={teamSitePath}/_layouts/15/TeamsWorkBench.aspx%3FcomponentId=%s%26teams%26personal%26forceLocale={locale}%26loadSPFX%3Dtrue%26debugManifestsFile%3Dhttps%3A%2F%2Flocalhost%3A4321%2Ftemp%2Fmanifests.js";
ManifestTemplate.LOCAL_CONFIGURATION_URL = "https://{teamSiteDomain}{teamSitePath}/_layouts/15/TeamsLogon.aspx?SPFX=true&dest={teamSitePath}/_layouts/15/TeamsWorkBench.aspx%3FcomponentId=%s%26openPropertyPane=true%26teams%26forceLocale={locale}%26loadSPFX%3Dtrue%26debugManifestsFile%3Dhttps%3A%2F%2Flocalhost%3A4321%2Ftemp%2Fmanifests.js";
ManifestTemplate.REMOTE_CONTENT_URL = "https://{teamSiteDomain}/_layouts/15/TeamsLogon.aspx?SPFX=true&dest=/_layouts/15/teamshostedapp.aspx%3Fteams%26personal%26componentId=%s%26forceLocale={locale}";
ManifestTemplate.REMOTE_CONFIGURATION_URL = "{{^config.isLocalDebug}}https://{teamSiteDomain}{teamSitePath}/_layouts/15/TeamsLogon.aspx?SPFX=true&dest={teamSitePath}/_layouts/15/teamshostedapp.aspx%3FopenPropertyPane=true%26teams%26componentId=%s%26forceLocale={locale}{{/config.isLocalDebug}}{{#config.isLocalDebug}}https://{teamSiteDomain}{teamSitePath}/_layouts/15/TeamsLogon.aspx?SPFX=true&dest={teamSitePath}/_layouts/15/TeamsWorkBench.aspx%3FcomponentId=%s%26openPropertyPane=true%26teams%26forceLocale={locale}%26loadSPFX%3Dtrue%26debugManifestsFile%3Dhttps%3A%2F%2Flocalhost%3A4321%2Ftemp%2Fmanifests.js{{/config.isLocalDebug}}";
ManifestTemplate.WEBSITE_URL = "https://products.office.com/en-us/sharepoint/collaboration";
ManifestTemplate.WEB_APP_INFO_RESOURCE = "https://{teamSiteDomain}";
ManifestTemplate.WEB_APP_INFO_ID = "00000003-0000-0ff1-ce00-000000000000";
//# sourceMappingURL=constants.js.map